<template>
  <div>
    <div style="align-items: start" class="row">
      <div style="padding-top: 30px" class="col-md-3">
        <div class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-none">Growth Moonshots</span>
            </div>
            <div class="text-card">
              <!-- {{dataMilestoneTimeline}} -->
              {{ dataMilestoneTimeline.grow }}
            </div>
          </div>
        </div>
        <div class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-none">Digital Moonshots</span>
            </div>
            <div class="text-card">
              {{ dataMilestoneTimeline.digital }}
            </div>
          </div>
        </div>
        <div class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-none">NZE Moonshots</span>
            </div>
            <div class="text-card">{{ dataMilestoneTimeline.nze }}</div>
          </div>
        </div>
        <div class="m-b-5 col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-none">Launchpad</span>
            </div>
            <div class="text-card">
              {{ dataMilestoneTimeline.launch }}
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="card small-widget mb-sm-0 bg-card-miles">
            <div class="card-body primary">
              <span class="f-14" style="font-weight: bold"
                >Total Milestone</span
              >
            </div>
            <div class="text-card">
              {{ dataMilestoneTimeline.total }}
            </div>
          </div>
        </div>
      </div>
      <div style="padding-top: 30px" class="col-md-3">
        <div class="row">
          <div
            style="
              border-radius: 10px;
              background-color: #00aa4e;
              height: 290px;
            "
            class="col-md m-r-5"
          >
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  align-self: center;
                "
              >
                {{ statusGreen[0] }}
              </div>
              <div
                style="
                  align-self: center;
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 3px;
                "
              >
                {{ statusGreen[1] }}
              </div>
              <div
                style="
                  align-self: center;
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 10px;
                "
              >
                {{ statusGreen[2] }}
              </div>
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusGreen[3] }}
              </div>
              <!-- <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusGreen[4] }}
              </div> -->
            </div>
          </div>
          <div
            style="
              background-color: #ff0b0b;
              border-radius: 10px;
              height: 290px;
            "
            class="col-md m-r-5"
          >
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                "
              >
                {{ statusRed[0] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-self: center;
                  align-content: center;
                  margin-top: 3px;
                "
              >
                {{ statusRed[1] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-self: center;
                  align-content: center;
                  margin-top: 10px;
                "
              >
                {{ statusRed[2] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-self: center;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusRed[3] }}
              </div>
              <!-- <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusRed[4] }}
              </div> -->
            </div>
          </div>
          <div
            style="
              background-color: #92caf8;
              border-radius: 10px;
              height: 290px;
            "
            class="col-md m-r-5"
          >
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                "
              >
                {{ statusBlue[0] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 3px;
                  align-self: center;
                "
              >
                {{ statusBlue[1] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 10px;
                  align-self: center;
                "
              >
                {{ statusBlue[2] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                  align-self: center;
                "
              >
                {{ statusBlue[3] }}
              </div>
              <!-- <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusBlue[4] }}
              </div> -->
            </div>
          </div>
          <div
            style="
              background-color: #8099d9;
              border-radius: 10px;
              height: 290px;
            "
            class="col-md m-r-5"
          >
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                "
              >
                {{ statusNav[0] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 3px;
                  align-self: center;
                "
              >
                {{ statusNav[1] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 10px;
                  align-self: center;
                "
              >
                {{ statusNav[2] }}
              </div>
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusNav[3] }}
              </div>
              <!-- <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusNav[4] }}
              </div> -->
            </div>
          </div>
          <div
            style="
              background-color: #c892f8;
              border-radius: 10px;
              height: 290px;
            "
            class="col-md"
          >
            <div style="display: flex; flex-direction: column">
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                "
              >
                {{ statusPurple[0] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 3px;
                  align-self: center;
                "
              >
                {{ statusPurple[1] }}
              </div>
              <div
                style="
                  color: white;
                  height: 66px;
                  align-self: center;
                  align-content: center;
                  margin-top: 10px;
                "
              >
                {{ statusPurple[2] }}
              </div>
              <div
                style="
                  color: white;
                  align-self: center;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
                {{ statusPurple[3] }}
              </div>
              <!-- <div
                style="
                  color: white;
                  height: 66px;
                  align-content: center;
                  margin-top: 7px;
                "
              >
              {{ statusPurple[4] }}
              </div> -->
            </div>
          </div>
        </div>
        <div
          class="m-t-10"
          style="
            display: flex;
            --bs-gutter-x: 1.5rem;
            --bs-gutter-y: 0;
            display: flex;
            flex-wrap: wrap;
            margin-top: calc(-1 * var(--bs-gutter-y));
            margin-right: calc(-0.5 * var(--bs-gutter-x));
            margin-left: calc(-0.5 * var(--bs-gutter-x));
          "
        >
          <div
            style="width: 39%; text-align: -webkit-center"
            class="m-r-5 bg-card-miles"
          >
            <div class="primary">
              <span style="font-weight: bold; font-size: small"
                >YEAR TO DATE</span
              >
            </div>
          </div>
          <div
            style="width: 20%; text-align: -webkit-center"
            class="m-r-5 mb-sm-0 bg-card-miles"
          >
            <div class="primary">
              <span style="font-weight: bold; font-size: small"
                >END OF NEXT WEEK</span
              >
            </div>
          </div>
          <div
            style="width: 18%; text-align: -webkit-center"
            class="m-r-2 mb-sm-0 bg-card-miles"
          >
            <div class="primary">
              <span style="font-weight: bold; font-size: small"
                >END OF FEB</span
              >
            </div>
          </div>
          <div
            style="width: 19%; text-align: -webkit-center"
            class="mb-sm-0 bg-card-miles"
          >
            <div class="primary">
              <span style="font-weight: bold; font-size: small"
                >REST OF THE YEAR</span
              >
            </div>
          </div>
        </div>
      </div>
      <div style="padding-top: 30px" class="col-md-6">
        <apexchart
          type="scatter"
          height="330"
          width="500px"
          :options="optionsMile"
          :series="seriesMile"
        ></apexchart>
        <!-- <apexchart
          type="scatter"
          height="70"
          :options="optionsMile"
          :series="filterGrowth"
        ></apexchart>
        <apexchart
          style="margin-top: -15px"
          type="scatter"
          height="70"
          :options="optionsMile"
          :series="filterDigital"
        ></apexchart>
        <apexchart
          style="margin-top: -15px"
          type="scatter"
          height="70"
          :options="optionsMile"
          :series="filterNze"
        ></apexchart>
        <apexchart
          style="margin-top: -15px"
          type="scatter"
          height="70"
          :options="optionsMile"
          :series="filterLaunchpad"
        ></apexchart>
        <div class="row">
          <div
            v-for="(item, id) in getKey"
            :key="id"
            style="width: 30%"
            :style="
              item.x !== 'jan' &&
              item.x !== 'feb' &&
              item.x !== 'mar' &&
              item.x !== 'apr'
                ? 'text-align:right'
                : ''
            "
            class="col mb-sm-0 bg-card-miles"
          >
            <div class="primary">
              <span style="font-weight: bold; font-size: small">{{
                item.x
              }}</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "statusGreen",
    "statusRed",
    "statusBlue",
    "statusNav",
    "statusPurple",
    "dataMilestoneTimeline",
    "dataProfit",
    "seriesMile",
    "optionsMile",
    "getKey",
    "filterGrowth",
    "filterDigital",
    "filterNze",
    "filterLaunchpad",
  ],
  components: {
    // IconSvg,
  },
  data() {
    return {
      isActiveMonth: false,
    };
  },
  methods: {
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
  },
};
</script>
